export const uabsConsultoriasMenu = {
    name: 'Consultorias',
    url: '/appsebrae/consultorias/uabs/consultorias',
    icon: 'fa fa-book',
    regras: ['APPSE-UABS-CONS-00']
}

export const uabsPagamentosMenu = {
    name: 'Pagamentos',
    url: '/appsebrae/consultorias/uabs/pagamentos',
    icon: 'fa fa-dollar',
    regras: ['APPSE-UABS-PAG-00']
}
